import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import { UserBetsReportLayer } from "../components/Report/UserBetsReportLayer";

export const UserBetsReportPage = () => (
  <MasterLayout>
    <UserBetsReportLayer />
  </MasterLayout>
);
